import React from 'react';

// Minimal hand-rolled sparkline — a single polyline over the supplied values.
export default function Sparkline({ values, width = 96, height = 24, color = '#d4a843' }) {
  if (!values || values.length === 0) {
    return <svg width={width} height={height} />;
  }
  const max = Math.max(...values, 0);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const n = values.length;
  const x = (i) => (n > 1 ? (i / (n - 1)) * (width - 2) + 1 : width / 2);
  const y = (v) => height - 1 - ((v - min) / range) * (height - 2);
  const points = values.map((v, i) => `${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const lastX = x(n - 1);
  const lastY = y(values[n - 1]);
  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      <polyline points={points} fill="none" stroke={color} strokeWidth={1.25} strokeLinejoin="round" />
      <circle cx={lastX} cy={lastY} r={1.6} fill={color} />
    </svg>
  );
}
